import styles from "./DisabledSearchView.module.scss";
import {
  isFastdupUser,
  isOnPremUser,
} from "../../../../../../../helpers/utility/utilities";
import { setShowLearnMoreModal } from "../../../../../../../redux/Modals/actions";
import { useDispatch } from "react-redux";
import { amplitudeTrack } from "../../../../../../../helpers/utility/amplitude";
import { clearFilters } from "../../../../../../../redux/SingleDataset/actions";
import { AMP_DATASET_EXPLORATION_EVENT__LEARN_MORE_MODAL__OPENED } from "../../../../../../../helpers/constants/amplitudeEvents";
import { useNavigate } from "react-router-dom";

export const DisabledSearchView = ({ datasetId }: { datasetId: string }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const disableEnrichButton = isFastdupUser() || isOnPremUser();
  const buttonText = disableEnrichButton ? "Learn more" : "Enrich data";
  const handleClick = () => {
    if (disableEnrichButton) {
      dispatch(setShowLearnMoreModal(true));
      amplitudeTrack(AMP_DATASET_EXPLORATION_EVENT__LEARN_MORE_MODAL__OPENED);
    } else {
      dispatch(clearFilters() as any);
      navigate(`/dataset/${datasetId}/enrich`);
    }
  };
  return (
    <div className={styles.DisabledSearchView}>
      <div>To enable search capabilities</div>
      <div className={styles.button} onClick={handleClick}>
        <ArrowIcon />
        {buttonText}
      </div>
    </div>
  );
};

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#fff"
      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM4.5 7.5a.5.5 0 1 0 0 1h5.793l-2.147 2.146a.5.5 0 1 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L10.293 7.5H4.5Z"
    />
  </svg>
);
